module.exports = __webpack_public_path__ + "static/img/profile.a4e6ea29.jpg";